import React from 'react';
import logo from '~src/assets/img/ironbank_logo.svg';
export const LoadingLogo = () => {
    return (React.createElement("div", { className: "loading-logo" },
        React.createElement("img", { className: "pulse", src: logo, alt: "ironbank_logo", width: "147px", height: "48px" })));
};
